// Copyright (c) Docugami, Inc. All rights reserved.

import { DgButton } from "components/common/DgCommonStyledComponents";
import { dgFontFamily } from "components/common/Fonts";
import { appContentColor, homeGray } from "components/shell/presentation/AppStyles";
import React, { ReactNode } from "react";
import styled from "styled-components";

export const CoachmarkInfoText = styled.span`
    font-family: ${dgFontFamily};
    font-size: 30px;
    font-weight: 400;
    line-height: 34px;
    color: ${homeGray};
`;

const RootContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: center;
    padding-left: 10%;
    padding-right: 10%;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow-y: auto;
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 50px;
    width: 100%;
    overflow-y: auto;
    align-items: center;
`;

const TitleText = styled.span`
    font-family: ${dgFontFamily};
    font-size: 24px;
    font-weight: 400;
    line-height: 28px;
    color: ${appContentColor};
`;

const SecondaryText = styled(CoachmarkInfoText)`
    font-size: 18px;
    line-height: 22px;
    white-space: pre-line;
`;

interface InfoViewAction {
    action: () => void;
    label: string;
}

export interface InfoViewProps {
    icon: JSX.Element;
    titleText?: ReactNode;
    secondaryText?: string[];
    confirmAction?: InfoViewAction;
    children?: ReactNode;
}

export const InfoView = (props: InfoViewProps): JSX.Element => {
    return (
        <RootContainer>
            <ContentContainer>
                {props.icon}
                {!!props.titleText && <TitleText>{props.titleText}</TitleText> }
                {!!props.secondaryText && props.secondaryText.map((text, i) => <SecondaryText key={`text_${i}`}>{text}</SecondaryText>)}
                {props.children}
                {!!props.confirmAction && <DgButton onClick={props.confirmAction.action}>{props.confirmAction.label}</DgButton> }
            </ContentContainer>
        </RootContainer>
    );
}
